// extracted by mini-css-extract-plugin
export var backdrop = "BaseModal-module--backdrop--29498";
export var dialog = "BaseModal-module--dialog--74e75";